import React from 'react';
import { textHighlightColor } from '../00_environment/Colors';

const HighligthedText = ({ children }) => (
  <span style={{ backgroundColor: textHighlightColor }}>{children}</span>
);

export default HighligthedText;
